import { ArrowUpRight } from "lucide-react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/ui/common/SecondaryFooter.tsx
/**
* Secondary footer rendered beneath the main theme footer on every page —
* "© {year} Powered by <logo> Aitisal ↗" linking to aitisaltech.com.
*/
function SecondaryFooter() {
	return /* @__PURE__ */ jsx("footer", {
		className: "w-full bg-white border-0 border-gray-200 border-t",
		children: /* @__PURE__ */ jsxs("div", {
			className: "mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-1.5 gap-y-1 px-4 py-3",
			children: [
				/* @__PURE__ */ jsxs("span", {
					className: "text-[13px] text-gray-500",
					children: [
						"© ",
						(/* @__PURE__ */ new Date()).getFullYear(),
						" Powered by"
					]
				}),
				/* @__PURE__ */ jsx("img", {
					src: "/icons/aitisal-app-logo.svg",
					alt: "Aitisal logo",
					className: "h-4 w-4",
					loading: "lazy",
					style: {
						width: "20px",
						height: "20px"
					}
				}),
				/* @__PURE__ */ jsxs("a", {
					href: "https://www.aitisaltech.com/",
					target: "_blank",
					rel: "nofollow sponsored noopener noreferrer",
					className: "group inline-flex items-center gap-0.5 text-[13px] font-semibold text-gray-800 underline underline-offset-2 transition-colors hover:text-gray-900",
					children: ["Aitisal", /* @__PURE__ */ jsx(ArrowUpRight, {
						className: "size-3.5 opacity-70 transition-opacity group-hover:opacity-100",
						strokeWidth: 1.5
					})]
				})
			]
		})
	});
}

//#endregion
export { SecondaryFooter as default };
//# sourceMappingURL=SecondaryFooter.mjs.map